import { z } from 'zod'

import { GetStatusSchema } from './status.ts'

export const GetCompanySchema = z.object({
  email: z.string().email().nullish(),
  id: z.number(),
  phone: z.string().nullish(),
  slug: z.string()?.nullish(),
  title: z.string(),
})

export const GetCompanyAccountSchema = z.object({
  registration_number: z.string().nullish(),
  vat: z.string().nullish(),
})

export const GetCompanyProfileSchema = z.object({
  adr: z.boolean(),
  curtain: z.boolean(),
  status: GetStatusSchema,
})
